//UI for each product to be displayed in the shop
import './Product.css'
import React, { useContext, useState } from 'react'
import {ShopContext} from '../../context/Shop-context'
import { Link } from 'react-router-dom';
import { ProductDetails } from '../ProductDetails/ProductDetails';
import { Cart } from '../cart/Cart';


export const Product = (props) => {

    const {id, productName, price, productImg, category, brand, color, weight, materials, frame, crank, videoSrc, otherDesc} = props.data;
    const containerCSS = 'mb-5 m-auto w-full items-center '
    const {cartItems, addToCart} = useContext(ShopContext)
    const {pid,setPid} = useState('') // pid = product id
    const cartItemAmount = cartItems[id]
    // const {apples, setApples} = useState(50);

    return(
    <div id='product-box' className='m-2 my-5 min-h-fit border border-gray-0 shadow-xl rounded-md '>
        <div id='products' className=' p-4 w-full h-full ' >
                <div id='' className='min-h-fit'>
                      {/* element={<ProductDetails pid={pid} productName={productName}/>} */}
                    <div id='image-container' className={containerCSS}>
                    <Link to={`/ProductDetails/${id}`} className='m-auto text-white' element={<ProductDetails data={props.data}/>}    >
                    <img className='m-auto items-center' id='product-img' src={productImg} alt={productName}/>
                    </Link>
                    </div>
                    <div id='Description' className='m-auto'>
                        <p className='m-auto'><b>{productName}</b></p>
                        <div id='price-button' className='m-auto w-60 flex justify-between items-center'>
                            {/* <button onClick={()=>details(id)}> Details</button> */}


                            <h3> {'\u20B9'} {price}/-</h3>
                            <button id='btn' className='border border-blue-800 w-36 h-8 '  onClick={()=>addToCart(id)}> Add to Cart {cartItems[id]>0 &&'(' +cartItems[id]+')'} </button>
                        </div>
                    </div>
                        <br></br>
                </div>
                {/* </Link> */}
              {/* </Link> */}
        </div> {/* products */}
    </div>
  )
}
